import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { setCurrentUser } from "../../redux/user/user.actions";

function AuthenticatedRoute({ component: C, appProps,isAuth, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuth
            ? <C {...props} {...appProps} />
            : <Redirect
                to={`/login?redirect=${props.location.pathname}${props.location.search}`}
              />}
      />
    );
}

const mapStateToProps = (state) => ({
    currentUser: state.user.currentUser,
    isAuth: state.user.isAuth,
  });
  const mapDispatchToProps = (dispatch) => ({
    setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  });
  export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedRoute);